import React, { FC } from 'react';
import { ChevronLeftIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { Category } from 'shared/types/product/Category';
import Button from 'components/commercetools-ui/atoms/button';
import HeaderLogo from 'components/commercetools-ui/organisms/header/header-logo';
import { useFormat } from 'helpers/hooks/useFormat';
import { ImageProps } from 'frontastic/lib/image';
import { MagnifyingGlassIcon as SearchIcon } from '@heroicons/react/24/solid';
import UtilitySection from '../../../utility-section';
import { useParams } from 'next/navigation';
import MarketButton from 'components/commercetools-ui/organisms/market-button/market-button';

export interface Props {
  logo: ImageProps;
  logoLink: string;
  categories: Category[];
  onArrowClick: () => void;
  hideHeaderMenu: () => void;
  showSearchBar?: boolean;
  setShowSearchBar?: any;
}

const MobileMenuHeader: FC<Props> = ({
  onArrowClick,
  logo,
  logoLink,
  hideHeaderMenu,
  categories,
  showSearchBar,
  setShowSearchBar,
}) => {
  const { formatMessage } = useFormat({ name: 'common' });
  const params = useParams();

  return (
    <div className="flex  w-full justify-between border-b border-neutral-400 px-16">
      <HeaderLogo
        logo={logo}
        logoLink={logoLink}
        onClick={hideHeaderMenu}
        imageClassName="flex h-68 text-16 font-bold w-[12rem]"
      />

      <div className="flex h-full items-center  gap-8 justify-end">
        <MarketButton />

        <Button
          variant="ghost"
          size="xs"
          onClick={hideHeaderMenu}
          title={formatMessage({ id: 'close', defaultMessage: 'Close' })}
          className="p-0"
        >
          <XMarkIcon className="w-24 text-secondary-black" />
        </Button>
      </div>
    </div>
  );
};

export default MobileMenuHeader;
